import { render, staticRenderFns } from "./MatrixBeam.vue?vue&type=template&id=4b1f0e3c&"
import script from "./MatrixBeam.vue?vue&type=script&lang=js&"
export * from "./MatrixBeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports